import { useState } from "react";
import CustomPlayer from "@/components/CustomPlayer";
import ChannelCarousel from "@/components/ChannelCarousel";
import * as S from "./styles";

export default function Tv() {
  const [currentUrl, setCurrentUrl] = useState("https://01.multicanaistv.win/bandsport/index.m3u8");

  return (
    <S.Container>
      <S.CarouselSection>
        <ChannelCarousel onChannelSelect={setCurrentUrl} currentUrl={currentUrl} />
      </S.CarouselSection>
      <S.PlayerSection>
        <CustomPlayer url={currentUrl} />
      </S.PlayerSection>
    </S.Container>
  );
}
